<template>
  <div v-if="visible" class="plus-wf-anchor-layer">
    <div class="plus-wf-anchor-layer__backdrop" @click="$emit('close')"></div>
    <div class="plus-wf-anchor-layer__panel wf-model-picker" :style="panelPositionStyle" @click.stop>
      <div class="wf-model-picker__head">
        <div class="wf-model-picker__title">模型</div>
        <div class="wf-model-picker__smart">
          <span class="wf-model-picker__smart-label">智能模型</span>
          <button
            type="button"
            class="wf-model-picker__toggle"
            :class="smartModel ? 'wf-model-picker__toggle--on' : ''"
            @click="smartModel = !smartModel"
          >
            <span class="wf-model-picker__toggle-knob"></span>
          </button>
        </div>
      </div>

      <div class="wf-model-picker__tabs-wrap">
        <div class="wf-model-picker__tabs">
          <button
            type="button"
            class="wf-model-picker__tab"
            :class="modelTab === 'image' ? 'wf-model-picker__tab--active' : ''"
            @click="modelTab = 'image'"
          >
            <i class="far fa-image"></i> 图片
          </button>
          <button
            type="button"
            class="wf-model-picker__tab"
            :class="modelTab === 'video' ? 'wf-model-picker__tab--active' : ''"
            @click="modelTab = 'video'"
          >
            <i class="fas fa-video"></i> 视频
          </button>
          <button
            type="button"
            class="wf-model-picker__tab"
            :class="modelTab === 'text' ? 'wf-model-picker__tab--active' : ''"
            @click="modelTab = 'text'"
          >
            <i class="fas fa-file-lines"></i> 文本
          </button>
        </div>
      </div>

      <div class="wf-model-picker__list-wrap">
        <div class="wf-model-picker__list">
          <button
            v-for="m in filteredModelOptions"
            :key="m.id"
            type="button"
            class="wf-model-picker__item"
            :class="m.id === modelId ? 'wf-model-picker__item--active' : ''"
            @click="onPick(m)"
          >
            <div class="wf-model-picker__icon">
              <i :class="m.icon"></i>
            </div>
            <div class="wf-model-picker__body">
              <div class="wf-model-picker__name-row">
                <div class="wf-model-picker__name">{{ m.name }}</div>
                <span v-if="m.badge" class="wf-model-picker__badge">{{ m.badge }}</span>
              </div>
              <div class="wf-model-picker__desc">{{ m.desc }}</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workflowAnchoredModalMixin from '@/mixins/workflowAnchoredModalMixin'
import { WORKFLOW_MODEL_OPTIONS } from '@/constants/workflowModelOptions'

export default {
  name: 'WorkflowModelPickerModal',
  mixins: [workflowAnchoredModalMixin],
  props: {
    visible: { type: Boolean, default: false },
    modelId: { type: String, default: '' }
  },
  data() {
    return {
      modelOptions: WORKFLOW_MODEL_OPTIONS,
      modelTab: 'image',
      smartModel: true
    }
  },
  computed: {
    filteredModelOptions() {
      const tab = ['image', 'video', 'text'].includes(this.modelTab) ? this.modelTab : 'image'
      return this.modelOptions.filter((m) => m.kind === tab)
    },
    panelPositionStyle() {
      return this.buildPanelPositionStyle()
    }
  },
  watch: {
    visible(v) {
      if (!v) return
      const m = this.modelOptions.find((x) => x.id === this.modelId)
      const kind = m && m.kind
      this.modelTab = ['image', 'video', 'text'].includes(kind) ? kind : 'image'
    }
  },
  methods: {
    getPanelLayoutOptions() {
      return { panelWidth: 420, panelMaxHeight: 400, gap: 10, align: 'left' }
    },
    onPick(m) {
      this.$emit('select', m)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.plus-wf-anchor-layer {
  position: fixed;
  inset: 0;
  z-index: 5000;
  pointer-events: none;
}
.plus-wf-anchor-layer__backdrop {
  position: fixed;
  inset: 0;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.12);
}
.plus-wf-anchor-layer__panel {
  position: fixed;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  overflow: hidden;
}
.wf-model-picker {
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 22%),
    linear-gradient(165deg, rgba(24, 24, 32, 0.98) 0%, rgba(14, 14, 18, 0.99) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 18px 48px -12px rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(14px);
}
.wf-model-picker__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.wf-model-picker__title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: rgba(255, 255, 255, 0.94);
}
.wf-model-picker__smart {
  display: flex;
  align-items: center;
  gap: 10px;
}
.wf-model-picker__smart-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.42);
}
.wf-model-picker__toggle {
  position: relative;
  width: 44px;
  height: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease;
}
.wf-model-picker__toggle--on {
  background: rgba(217, 70, 239, 0.28);
  border-color: rgba(217, 70, 239, 0.35);
}
.wf-model-picker__toggle-knob {
  position: absolute;
  top: 50%;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  transform: translateY(-50%);
  transition: transform 0.18s ease;
}
.wf-model-picker__toggle--on .wf-model-picker__toggle-knob {
  transform: translate(20px, -50%);
}
.wf-model-picker__tabs-wrap {
  padding: 12px 16px 8px;
}
.wf-model-picker__tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 4px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.22);
}
.wf-model-picker__tab {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.42);
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
}
.wf-model-picker__tab:hover {
  color: rgba(255, 255, 255, 0.72);
}
.wf-model-picker__tab--active {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.wf-model-picker__list-wrap {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 4px 12px 14px;
}
.wf-model-picker__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.wf-model-picker__item {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 12px 36px 12px 12px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.025);
  text-align: left;
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    transform 0.15s ease,
    box-shadow 0.18s ease;
}
.wf-model-picker__item:hover {
  border-color: rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-1px);
}
.wf-model-picker__item--active {
  border-color: rgba(129, 140, 248, 0.38);
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.18) 0%, rgba(56, 189, 248, 0.08) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 0 1px rgba(129, 140, 248, 0.12);
}
.wf-model-picker__item--active::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 700;
  color: rgba(165, 180, 252, 0.95);
}
.wf-model-picker__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.02) 100%);
  color: rgba(255, 255, 255, 0.82);
}
.wf-model-picker__item--active .wf-model-picker__icon {
  border-color: rgba(165, 180, 252, 0.28);
  background: linear-gradient(145deg, rgba(129, 140, 248, 0.22) 0%, rgba(56, 189, 248, 0.1) 100%);
}
.wf-model-picker__body {
  min-width: 0;
  flex: 1;
}
.wf-model-picker__name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.wf-model-picker__name {
  font-size: 14px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.94);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wf-model-picker__badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(217, 70, 239, 0.28);
  background: rgba(217, 70, 239, 0.16);
  font-size: 10px;
  font-weight: 700;
  color: rgba(244, 114, 182, 0.95);
}
.wf-model-picker__desc {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.42);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
